import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class PartErrorMixin extends Vue {
  hasError() {
    const errors = this.$store.state.entities.part.error;
    return !(!errors || !errors.length);
  }
}

export default PartErrorMixin;